import BaseApiService from "./base-services/baseApi.service";

class CartApiService extends BaseApiService {
    constructor() {
        super();
    }

    getTimeSlot = async (skipDays) => {
        const url = `/order/cart/time-slot?skipDays=${skipDays}`;
        const res = await this.axiosInstance.get(url);
        return await res.data;
    };
    removeCartItem = async (payload) => {
        const url = `/order/cart/remove-cart-item`;
        const res = await this.axiosInstance.delete(url, payload);
        return res;
    };

    getCoupon = async (payload) => {
        const url = `/order/cart/apply-voucher`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    getCouponLists = async () => {
        const url = `/website/get-vouchers`;
        const res = await this.axiosInstance.get(url);
        return res;
    };

    cancelHomeVisit = async () => {
        const url = `/website/get-vouchers`;
        const res = await this.axiosInstance.get(url);
        return res;
    };

    removeCoupon = async (payload) => {
        const url = `/order/cart/remove-voucher`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    getCheckoutPayment = async (payload) => {
        const url = `/order/checkout/order`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    getUploadedDetails = async (visitType) => {
        const url = `website/cart/required-docs?visitType=${visitType}`;
        const res = await this.axiosInstance.get(url);
        return await res.data;
    };

    getCartCount = async () => {
        const url = `/order/cart/count`;
        const res = await this.axiosInstance.get(url);
        return await res.data;
    };

    getCheckoutMethod = async () => {
        const url = `/order/cart/payment-methods`;
        const res = await this.axiosInstance.get(url);
        return res.data;
    };

    getUpdateStatus = async (payload) => {
        const url = `/order/cart/update-status`;
        const res = await this.axiosInstance.put(url, payload);
        return await res.data;
    };

    uploadPatientDoc = async (payload) => {
        const url = `/action/upload-patient-doc`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    getUploadUrl = async (payload) => {
        const url = `/ticket/url/s3/file`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    // uploadObject = async (file, path) => {
    //     const filePath = imagePath[path];
    //     let formData = new FormData();

    //     formData.append("file", file);
    //     formData.append("filePath", filePath);

    //     const url = `/third-party/aws/s3/image`;
    //     const response = await this.axiosInstance.post(url, formData);
    //     return response.data;
    // };

    uploadPatientRecord = async (file) => {
        let formData = new FormData();
        formData.append("file", file);

        const url = `/action/upload-patient-doc`;
        const response = await this.axiosInstance.post(url, formData);
        return response.data;
    };

    removeAllCart = async (payload) => {
        const url = `/order/cart/remove-cart`;
        const res = await this.axiosInstance.delete(url, { data: payload });
        return res;
    };

    switchToNewCartAddress = async (payload) => {
        const url = `/order/cart/switch-to-new-cart-address`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    switchToOldCartAddress = async (payload) => {
        const url = `/order/cart/switch-to-old-cart`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    cancelHomeVisit = async (payload) => {
        const url = `/order/cart/home-visit-cancel`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    updateOrderDetails = async (payload, headers) => {
        const url = `/order/cart/gtag-order-detail`;
        const res = await this.axiosInstance.post(url, payload, headers);
        return res;
    };

    getPetCTItemList = async () => {
        const url = `/pet-ct/item-list`;
        const res = await this.axiosInstance.get(url);
        return res.data;
    };

    getPetCtDate = async (queryParams) => {
        const { offsetBy, testId, centreId, validationType, hideEarlySlot } =
            queryParams;
        const url = `/pet-ct/date-time-slot?offsetBy=${offsetBy}&testId=${testId}&centreId=${centreId}&validationType=${validationType}&hideEarlySlot=${hideEarlySlot}`;
        const res = await this.axiosInstance.get(url);
        return res.data?.data;
    };

    getPetCtTimeSlot = async (queryParams) => {
        const { monthDate, testId, centreId, dateType } = queryParams;
        const url = `/pet-ct/date-time-slot?monthDate=${monthDate}&testId=${testId}&centreId=${centreId}&dateType=${dateType}`;
        const res = await this.axiosInstance.get(url);
        return res.data?.data;
    };

    getCreateCheckout = async (payload) => {
        const url = `/pet-ct/create-checkout`;
        const res = await this.axiosInstance.post(url, payload);
        return res?.data;
    };

    getValidateTimeSlot = async (payload) => {
        const url = `/pet-ct/validate-time-slot`;
        const res = await this.axiosInstance.post(url, payload);
        return res?.data?.data;
    };

    getCompleteCheckout = async (payload) => {
        const url = `/pet-ct/complete-checkout`;
        const res = await this.axiosInstance.post(url, payload);
        return res?.data?.data;
    };
    uploadPetctDoc = async (payload) => {
        const url = `/action/upload-petct-doc`;
        const res = await this.axiosInstance.post(url, payload);
        return res?.data;
    };

    updatePetCtAppointment = async (payload) => {
        const url = `/pet-ct/update-checkout`;
        const res = await this.axiosInstance.post(url, payload);
        return res?.data;
    };

    applyCoupon = async (payload) => {
        const url = `/pet-ct/apply-voucher`;
        const res = await this.axiosInstance.post(url, payload);
        return res?.data;
    };

    removePetCtCoupon = async (payload) => {
        const url = `/pet-ct/remove-voucher`;
        const res = await this.axiosInstance.post(url, payload);
        return res?.data;
    };
}

const cartApiService = new CartApiService();
export { cartApiService };
